import type { JSX } from 'react';

import { Helmet } from 'react-helmet-async';

export function PageMeta(): JSX.Element {
	// const { translate } = useI18n();
	// const title = translate('corgi.location_page_sitemap.meta.title');
	// const description = translate('corgi.location_page_sitemap.meta.description');

	const title = 'Browse by Location';
	const description =
		'Find petitions near you and support local change. Explore what’s happening in your community on Change.org.';
	const canonicalUrl = 'https://www.change.org/local';

	return (
		<Helmet>
			<link rel="canonical" href={canonicalUrl}></link>
			<title>{title}</title>
			<meta property="title" content={title} />
			<meta name="description" content={description} />
			<meta property="og:url" content={canonicalUrl} />
			<meta property="og:title" content={title} />
			<meta property="twitter:image:alt" content={title} />
			<meta property="og:type" content="website" />
		</Helmet>
	);
}
